import './modules/bling';
import RaceResults from './modules/race-results';
import PresidentResults from './modules/president-sum';

const u = new URL(window.location.href);
var domain = u.searchParams.get("market") || window.pageInfo["marketInfo.domain"];
var manualMarket = u.searchParams.has("market");

/**
 * Renders the race results grid.
 * Multiple urls can be passed in for cross-state markets.
 */

async function renderRaceResults(endpoint, container = ".omnibus") {
  const embed = document.querySelector(container);
  const toast = document.querySelector("#election-toast");

  toast.show();

  // Clear out the last round
  while(embed.firstChild) {
    embed.removeChild(embed.lastChild);
  }

  // Proceed to add them back
  let feed = await fetch(endpoint).then( response => response.json() );

  for(const [name, races] of Object.entries(feed.results)) {
    let wrapper = document.createElement("div");
    embed.appendChild(wrapper);

    // Inject the name
    wrapper.insertAdjacentHTML("afterbegin", `<h2 class="e-header">${name}</h2>`);

    let grid = document.createElement("div");
    grid.classList.add("grid");
    wrapper.appendChild(grid);

    races.forEach(race => {
      const id = race.record_id;
      const div = document.createElement("div");
      const results = new RaceResults();

      div.classList.add("election-group", "race-group");
      div.dataset.race = id;

      grid.appendChild(div);
      results.selection(`${container} .election-group[data-race="${id}"]`).props({ raceID: id, recordKey: 'record_id' }).data(races).render();
    });
  }

  toast.hide();
}

/**
 * Renders the Electoral College Votes
 */

async function renderElectoralCollege(url) {
  const { data } = await fetch(url).then(response => response.json());
  const presResults = new PresidentResults();
  presResults.selection('.pres-ev-results').data(data).render();
}

/**
 * Omnibus tabs element for KC
 */

class OmniTabs extends HTMLElement {

  get template() {
    let t = document.createElement("template");
    t.innerHTML = `
    <style>
      :host {
        display: block;
      }

      .tabs {
        border-bottom: 1px solid #ddd;
        display: flex;
      }

      .tabs span {
        font: 1rem/1em var(--sans);
        padding: 15px 30px;
        cursor: pointer;
        border: 1px solid #ddd;
        border-bottom: none;
        border-radius: 2px 2px 0 0;
        color: #757575;
      }

      .tabs span:nth-child(n+2) {
        border-left: none;
      }

      .tabs span.active {
        background-color: white;
        color: #222;
      }

      .panels::slotted(*) {
        display: none;
      }

      .panels::slotted(.active) {
        display: block;
      }

      @media(max-width: 600px) {
        .tabs {
          padding: 0 15px;
        }
      }
    </style>

    <div class="tabs"></div>
    <slot class="panels"></slot>
    `;
    return t;
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.shadowRoot.appendChild(this.template.content.cloneNode(true));

    // Convenience
    this._tabs = this.shadowRoot.querySelector(".tabs");
    this._slot = this.shadowRoot.querySelector(".panels");
  }

  connectedCallback() {
    this._tabs.addEventListener("click", this.handleTabClick.bind(this));
    this._slot.addEventListener("slotchange", this.handleSlotChange.bind(this));
  }

  set active(val) {
    let tabs = this._tabs.children;
    for(let i = 0; i < tabs.length; i++) {
      tabs[i].classList.toggle("active", i == val);
    }

    let children = this._slot.assignedElements();
    for(let i = 0; i < children.length; i++) {
      children[i].classList.toggle("active", i == val);
    }
  }

  handleSlotChange(e) {
    // Clear the tabs
    while(this._tabs.firstChild) {
      this._tabs.removeChild(this._tabs.lastChild)
    }

    // Add the new ones
    let children = this._slot.assignedElements();
    children.forEach(ele => {
      let tab = ele.getAttribute("tab");
      if(tab) {
        this._tabs.insertAdjacentHTML("beforeend", `<span>${tab}</span>`);
      }
    })

    this.active = 0;
  }

  handleTabClick(e) {
    let index = Array.from(e.currentTarget.children).indexOf(e.target);
    if(index > -1) this.active = index;
  }
}

// Register the element
customElements.define("omni-tabs", OmniTabs);

/**
 * Domain map for id
 */

function getMarket() {
  const reports = [{"id":"54","url":"https://www.bnd.com"},{"id":"124","url":"https://www.bellinghamherald.com"},{"id":"24","url":"https://www.bradenton.com"},{"id":"94","url":"https://www.centredaily.com"},{"id":"79","url":"https://www.charlotteobserver.com"},{"id":"29","url":"https://www.elnuevoherald.com"},{"id":"4","url":"fresnobee.com"},{"id":"104","url":"https://www.heraldonline.com"},{"id":"84","url":"https://www.heraldsun.com"},{"id":"49","url":"https://www.idahostatesman.com"},{"id":"109","url":"https://www.islandpacket.com"},{"id":"74","url":"https://www.kansascity.com"},{"id":"39","url":"https://www.ledger-enquirer.com"},{"id":"64","url":"https://www.kentucky.com"},{"id":"9","url":"https://www.mercedsunstar.com"},{"id":"34","url":"https://www.miamiherald.com"},{"id":"14","url":"https://www.modbee.com"},{"id":"89","url":"https://www.newsobserver.com"},{"id":"129","url":"https://www.thenewstribune.com"},{"id":"134","url":"https://www.theolympian.com"},{"id":"1","url":"sacbee.com"},{"id":"19","url":"https://www.sanluisobispo.com"},{"id":"119","url":"https://www.star-telegram.com"},{"id":"114","url":"https://www.thestate.com"},{"id":"69","url":"https://www.sunherald.com"},{"id":"99","url":"https://www.myrtlebeachonline.com"},{"id":"44","url":"https://www.macon.com"},{"id":"139","url":"https://www.tri-cityherald.com"},{"id":"59","url":"https://www.kansas.com"}]

  // domain defined globally at the top for reuse throughout this script
  return reports.find(d => d.url.match(`${domain}.com`));
}

/**
 * KC multi-state template swap
 */

if(domain == "kansascity") {
  const omnibus = document.querySelector("#omnibus");
  const oTemplate = document.querySelector("#kansascity-omnibus")
  omnibus.appendChild(oTemplate.content.cloneNode(true));
}

/**
 * Redraws every 3 minutes
 */

async function redraw() {
  const market = getMarket();

  if(manualMarket) {
    document.querySelector(".elections-2020").hidden = true;
  } else {
    renderElectoralCollege(`https://media.mcclatchy.com/2020/elections/results/1/presidential_report.json?v=2`);
  }

  if(domain == "kansascity") {
    await renderRaceResults(`https://media.mcclatchy.com/2020/elections/results/146/results.json`, "#ks-results");
    await renderRaceResults(`https://media.mcclatchy.com/2020/elections/results/74/results.json?v=2`, "#mo-results");
  } else {
    await renderRaceResults(`https://media.mcclatchy.com/2020/elections/results/${market.id}/results.json`);
  }
}

// Start the motion in the ocean
redraw();
window.setInterval(async () => {
  const currentY = window.scrollY;
  await redraw();
  window.scrollTo(0, currentY);
}, 180000);
